import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  displayDateTimeField,
  displayField,
  isNotEmpty,
} from "../../../utils/helpers";
import { orderStatusObj } from "../../../core/config/AppConstants";

const OrderAssignedServedCell = ({
  rowData,
  positionFromRight = "20",
  displayTitle = "service_by",
  withOrderStatus = false,
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
  displayTitle?: string;
  withOrderStatus?: boolean;
}) => {
  let orderStatus: String = rowData.order_status;
  const { t } = useTranslation();
  const { Cell } = Table;
  let displayT = isNotEmpty(rowData.served_by_name)
    ? displayField(rowData.served_by_name)
    : displayField(rowData.order_assigned_to_name);

  if (displayTitle == "order_status")
    displayT = displayField(rowData.order_status);
  const speaker = (
    <Popover title={t("ORDER") + " " + t("SERVICE") + ":"}>
      <p>
        {displayTitle == "order_status" && (
          <p>
            <b>
              {t("ORDER")} {t("STATUS")}:
            </b>
            {" " + displayField(rowData.order_status)}

            {isNotEmpty(rowData.order_cancellation_reason) && (
              <p>
                {" "}
                <b>{t("CANCELLATION") + " " + t("REASON")}:</b>{" "}
                {displayField(rowData.order_cancellation_reason)}
              </p>
            )}
            {isNotEmpty(rowData.cancelled_at) && (
              <p>
                {" "}
                <b>{t("CANCELLED") + " " + t("AT")}:</b>{" "}
                {displayDateTimeField(rowData.cancelled_at)}
              </p>
            )}
          </p>
        )}
        <p>
          <b>
            {t("ASSIGNED")} {t("TO")}
          </b>
          : {displayField(rowData.order_assigned_to_name)}
          {isNotEmpty(rowData.order_assigned_to_phone) && (
            <> {"(" + rowData.order_assigned_to_phone + ")"}</>
          )}
        </p>
        <p>
          <b>
            {t("SERVED")} {t("BY")}
          </b>
          : {displayField(rowData.served_by_name)}
          {isNotEmpty(rowData.served_by_phone) && (
            <> {"(" + rowData.served_by_phone + ")"}</>
          )}
          {isNotEmpty(rowData.served_at) && (
            <> {t("AT") + " " + displayDateTimeField(rowData.served_at)}</>
          )}
        </p>
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayT}</a>
      </Whisper>
    </Cell>
  );
};

export default OrderAssignedServedCell;
